<template>
  <div id="content">
    <popup v-show="hasPopup"
           :popup-type="getPopupType"
           :popup-action="getPopupAction"
           @popup-action="executePopupAction"></popup>
    <form>
      <div class="inner">
        <add-button
            v-if="$_createActionAllowed"
            :title="'Přidat blokovaný obsah' | translate"
            route-name="blackoutContentNew"
        ></add-button>
        <h1 v-translate>Blokovaný obsah</h1>
      </div>
      <div class="inner_white">
        <div class="filter">
          <div class="field_left">
            <search-input input-class="search" v-model="formFields.search" />
          </div>
          <div class="field_left">
            <select-box
                id="id_epg"
                :options="epgOptions"
                v-model="formFields.id_epg"
                ref="idepgref"
            >
              <translate class="translate">Id EPG</translate>
            </select-box>
          </div>
          <div class="field_right">
            <select-box
                id="enabled"
                :options="enabledOptions"
                v-model="formFields.enabled"
                ref="enabledref"
            >
              <translate class="translate">Povoleno</translate>
            </select-box>
          </div>
          <div class="field_left">
            <date-picker
                id="from_timestamp"
                attrKey="from_timestamp"
                date-format="d. m. yy"
                v-model="formFields.from_timestamp"
                @update-date="updateFormDate"
            >
              <translate class="translate">Blokovat od</translate>
            </date-picker>
          </div>
          <div class="field_right">
            <date-picker
                id="to_timestamp"
                attrKey="to_timestamp"
                date-format="d. m. yy"
                v-model="formFields.to_timestamp"
                @update-date="updateFormDate"
            >
              <translate class="translate">Blokovat do</translate>
            </date-picker>
          </div>
          <a @click.stop.prevent="resetFilter" class="btn btn_action btn_grey btn_reset"
             :title="'Resetovat filtr' | translate" v-translate>Resetovat filtr</a>
        </div>
        <form>
          <div class="scroll-wrapper">
            <div class="table_overflow" id="contentBox" data-table-id="blackout-content-list">
              <table class="vypis" ref="table_with_action_line" v-show="dataLoaded">
                <thead>
                <tr v-if="entities.length > 0">
                  <th class="no_padding drag_drop"></th>
                  <th class="no_padding checkbox"></th>
                  <sorting-table-title
                      v-for="title in sortingTableTitles"
                      :key="title.key"
                      :column="title.column"
                      :sortable="title.sortable"
                      :sort="getActiveSort(title.column)"
                      @changeSorting="changeSorting"
                  >{{ title.name }}
                  </sorting-table-title>
                  <th class="no_padding edit"></th>
                </tr>
                </thead>
                <BlackoutContentRow v-for="entity in entities"
                                    :entity="entity"
                                    :key="entity.id"
                                    :selectedEntities="selectedEntities"
                                    ref="blackout_content_row"
                                    @input="select"
                                    @updateEntity="updateEntity"
                                    @deleteEntity="deleteEntity"
                ></BlackoutContentRow>
                <tr v-if="entities.length === 0">
                  <td colspan="8" v-translate>Nebyl nazelen žádný blokovaný obsah.</td>
                </tr>
              </table>
            </div>
          </div>
          <list-action-line
              :entities="entities"
              :selected-entities="selectedEntities"
              :multiple-action-options="multipleActionOptions"
              :offset="formFields.offset"
              :limit="formFields.limit"
              :total-count="totalCount"
              table-id="blackout-content-list"
              @select-all="toggleSelectAll"
              @run-multiple-action="runMultipleAction"
              @limit="setLimit"
              @offset="setOffset"
              ref="action_line"
          ></list-action-line>
        </form>
      </div>
    </form>
  </div>
</template>

<script>
import listActions from "../../mixins/list-actions";
import BlackoutContentRow from "./BlackoutContentRow.vue";
import {getBooleanOrNullListOptions} from "../../../utils/helpers";

export default {
  name: "BlackoutContentList",
  components: {
    BlackoutContentRow
  },
  mixins: [listActions],
  data() {
    return {
      moduleName: 'blackout_contents',
      dateFields: ['from_timestamp', 'to_timestamp'],
      epgOptions: [],
      enabledOptions: getBooleanOrNullListOptions(this),
      formFields: {
        sort: {
          column: 'sIdEpg',
          direction: 'desc',
        },
        id_epg: null,
        enabled: null,
        from_timestamp: null,
        to_timestamp: null,
      },
    }
  },
  created(BlackoutContentService, ChannelService) {
    this.entityService = BlackoutContentService;
    this.channelService = ChannelService;
    this.createdInit();
    this.channelService.epgChannelList()
        .then((data) => {
          this.epgOptions = Object.values(data['channels']);
          this.epgOptions.unshift({id: null, text: this.$gettext('Všechny')});
        });
  },
  computed: {
    sortingTableTitles() {
      return [
        {key: 1, name: this.$gettext('EPG kanál'), column: 'sEpgChannel'},
        {key: 2, name: this.$gettext('Název'), column: 'sName'},
        {key: 3, name: this.$gettext('Blokovat od'), column: 'sFromTimestamp'},
        {key: 4, name: this.$gettext('Blokovat do'), column: 'sToTimestamp'},
        {key: 5, name: this.$gettext('Operátor'), column: 'sOperatorName'},
        {key: 6, name: this.$gettext('Povoleno'), column: 'sEnabled'},
        {key: 7, name: this.$gettext('Timeshift'), column: 'sAllowTimeshift'},
        {key: 8, name: this.$gettext('Catchup'), column: 'sAllowCatchup'},
        {key: 9, name: this.$gettext('PVR'), column: 'sAllowPvr'},
        {key: 10, name: this.$gettext('Povolené regiony'), column: 'sAllowedRegions', sortable: false},
        {key: 11, name: this.$gettext('Zakázané regiony'), column: 'sRestrictedRegions', sortable: false},
        {key: 12, name: this.$gettext('Upraveno'), column: 'sDateUpdated'},
      ]
    },
    multipleActionOptions() {
      return [
        {value: 'choose', text: this.$gettext('Vyberte akci')},
        {value: 'exportCsv', text: this.$gettext('Exportovat do CSV')}
      ]
    },
    csvHeaders() {
      let headers = this.getCsvHeaderFromSortingTableTitle(this.sortingTableTitles);
      headers.enabled.callback = entity => {
        return entity.enabled ? this.$gettext('Ano') : this.$gettext('Ne')
      };
      headers.allow_timeshift.callback = entity => {
        return entity.allow_timeshift ? this.$gettext('Ano') : this.$gettext('Ne')
      };
      headers.allow_catchup.callback = entity => {
        return entity.allow_catchup ? this.$gettext('Ano') : this.$gettext('Ne')
      };
      headers.allow_pvr.callback = entity => {
        return entity.allow_pvr ? this.$gettext('Ano') : this.$gettext('Ne')
      };
      headers.from_timestamp.callback = (entity) => {
        return entity.from_timestamp ? this.$_datetime_format(entity.from_timestamp) : ''
      };
      headers.to_timestamp.callback = (entity) => {
        return entity.to_timestamp ? this.$_datetime_format(entity.to_timestamp) : ''
      };
      headers.allowed_regions.callback = (entity, index) => {
        return this.$refs.blackout_content_row[index].allowedRegionsText(entity.allowed_regions, entity.restricted_regions)
      };
      headers.restricted_regions.callback = (entity, index) => {
        return this.$refs.blackout_content_row[index].restrictedRegionsText(entity.allowed_regions, entity.restricted_regions)
      };

      return headers;
    },
  },
  methods: {
    loadAdditionalDefaults() {
      let anyChanges = false
      if (this.loadDefaultByKey('id_epg')) {
        anyChanges = true
      }
      if (this.loadDefaultByKey('enabled')) {
        anyChanges = true
      }
      if (this.loadDefaultByKey('from_timestamp')) {
        anyChanges = true
      }
      if (this.loadDefaultByKey('to_timestamp')) {
        anyChanges = true
      }
      return anyChanges
    },
    saveFilterValues() {
      this.saveSearch(this.formFields.search)
      this.setUserSetting('id_epg', this.formFields.id_epg);
      this.setUserSetting('enabled', this.formFields.enabled);
      this.setUserSetting('from_timestamp', this.formFields.from_timestamp);
      this.setUserSetting('to_timestamp', this.formFields.to_timestamp);
    },
    updateFormDate(dateInfo) {
      this.formFields[dateInfo.attrKey] = dateInfo.date
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/views/blackoutContents/BlackoutContentList.vue